import { render, staticRenderFns } from "./ProgramCategoryList.vue?vue&type=template&id=5e0a1834&"
import script from "./ProgramCategoryList.vue?vue&type=script&lang=js&"
export * from "./ProgramCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports